import { LuIcon, Menu } from "@overmap-ai/blocks"
import { type BooleanField, fieldDataMapping } from "@overmap-ai/forms"
import { use } from "react"

import { SelectItemTemplate } from "../../../components/MenuGroups/constants"
import { FilterModifierDropdown, RemoveFilterButton } from "../../components"
import { FilterCellBadge } from "../../components/FilterCellBadge"
import { FilterCellButton } from "../../components/FilterCellButton"
import { FilterCellRoot } from "../../components/FilterCellRoot"
import { FilterRendererContext } from "../../contexts/FilterRendererContext/context"
import type { FilterDefRenderProps } from "../BaseFilterDef"
import type { BooleanFieldFilterDef } from "./BooleanFieldFilterDef"

interface BooleanFieldFilterCellProps extends FilterDefRenderProps<BooleanFieldFilterDef> {
	field: BooleanField
}

export const BooleanFieldFilterCell = (props: BooleanFieldFilterCellProps) => {
	const { field, filterDef, filter, filterManager } = props

	const { size } = use(FilterRendererContext)

	const filterValue = filter.getFilterValue()
	const filterModifier = filter.getFilterModifier()

	const getFilterValueRender = () => {
		switch (filterValue) {
			case undefined:
				return "..."
			case true:
				return "true"
			case false:
				return "false"
			case null:
				return "empty"
		}
	}

	return (
		<FilterCellRoot>
			<FilterCellBadge className="shrink-1 min-w-0">
				<LuIcon icon={fieldDataMapping[field.type].icon} />
				<span className="truncate">{field.label}</span>
			</FilterCellBadge>

			<FilterModifierDropdown filterDef={filterDef} filter={filter}>
				<FilterCellButton>
					{filterDef.getFilterModifier(filterModifier).modifier.render(filterValue)}
				</FilterCellButton>
			</FilterModifierDropdown>

			<Menu.Root>
				<Menu.ClickTrigger>
					<FilterCellButton className="shrink-1 min-w-0 grow">{getFilterValueRender()}</FilterCellButton>
				</Menu.ClickTrigger>
				<Menu.Content size={size}>
					<Menu.SelectGroup<boolean | null>
						required
						value={filterValue}
						onValueChange={filter.setFilterValue}
					>
						<SelectItemTemplate<boolean | null> value={true}>true</SelectItemTemplate>
						<SelectItemTemplate<boolean | null> value={false}>false</SelectItemTemplate>
						<SelectItemTemplate<boolean | null> value={null}>empty</SelectItemTemplate>
					</Menu.SelectGroup>
				</Menu.Content>
			</Menu.Root>

			<RemoveFilterButton filter={filter} filterManager={filterManager} />
		</FilterCellRoot>
	)
}
